import ZFigure from './ZFigure.vue'
export default ZFigure
